import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import langEng from 'assets/images/Language-en.png';
import langJa from 'assets/images/Language-ja.png';

import { Dropdown, Menu, Space } from 'antd';
import React from 'react';
// actions
import { changeLanguageAction } from 'redux/actions/config';

const LanguageMenu = (props) => {
    const { i18n, onChangeLanguage } = props;

    const changeLanguage = (lang) => {
        i18n.changeLanguage(lang);
        onChangeLanguage(lang);
    };

    return (
        <Menu
            items={[
                {
                    key: '1',
                    label: (
                        <a target="_blank" rel="noopener noreferrer" onClick={() => changeLanguage('en')}>
                            <div className="lang-item">
                                <img src={langEng} alt="" />
                                <span>EN</span>
                            </div>
                        </a>
                    ),
                },
                {
                    key: '2',
                    label: (
                        <a target="_blank" rel="noopener noreferrer" onClick={() => changeLanguage('ja')}>
                            <div className="lang-item">
                                <img src={langJa} alt="" />
                                <span>JA</span>
                            </div>
                        </a>
                    ),
                },
            ]}
        />
    );
};

const LanguageSwitcher = () => {
    const { i18n } = useTranslation();

    const language = useSelector((state) => state.config.currentLanguage);

    const dispatch = useDispatch();

    const onChangeLanguage = (lang) => {
        dispatch(changeLanguageAction(lang));
    };

    return (
        <Dropdown
            className="language-switcher-wrapper"
            overlay={<LanguageMenu i18n={i18n} onChangeLanguage={onChangeLanguage} />}
        >
            <div onClick={(e) => e.preventDefault()}>
                <Space>
                    <div className="lang-btn">
                        <img src={language === 'en' ? langEng : langJa} alt="" />
                        <span>{language.toUpperCase()}</span>
                    </div>
                </Space>
            </div>
        </Dropdown>
    );
};

export default LanguageSwitcher;
